import classes from "./Metrics.module.css";
export default function MetricsMenu() {
  return (
    <div className={classes.menu}>
      <input
        type="text"
        placeholder="Search for metric..."
        className={classes.searchBar}
      />
      <div className={classes.sortFilter}>
        <button className={classes.addNewMetricBtn}>Add new metric</button>
        <button className={classes.filterBtn}>Filter</button>
        <button className={classes.sortBtn}>Sort</button>
      </div>
    </div>
  );
}
